import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export default function useSeo({ title, description, image } = {}) {
  useEffect(() => {
    const base = "VISION LOGICIELS";
    if (title) document.title = `${title} — ${base}`;
    if (description) setMeta("name", "description", description);
    setMeta("property", "og:title", title ? `${title} — ${base}` : base);
    if (description) setMeta("property", "og:description", description);
    if (image) setMeta("property", "og:image", image);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary_large_image");
    return () => { document.title = "VISION LOGICIELS — Solutions technologiques performantes"; };
  }, [title, description, image]);
}
